import React from 'react';
import { Button, Form, Input,Modal } from 'antd';
import {editPwd} from '../../api/user'

const App = (props) => {
  const onFinish = values => {
  console.log('Success:', values);
 // return
  editPwd(values).then(res=>{
    props.handleCancel()
  })
};
const onFinishFailed = errorInfo => {
  //console.log('Failed:', errorInfo);
  
};
  return <Modal
        open={props.open}
        title="修改密码"
        //onOk={handleOk}
        onCancel={props.handleCancel}
        width={600}
        footer={null}
        >
             <Form
    name="basic"
    labelCol={{ span: 6 }}
    wrapperCol={{ span: 16 }}
    initialValues={{ remember: true }}
    onFinish={onFinish}
    onFinishFailed={onFinishFailed}
    autoComplete="off"
    
  >
    <Form.Item
     label="手机号" name="userName"
      rules={[
          {
            required: true,
            message: '输入手机号',
          },
          () => ({
            validator(_, value) {
              if (value && !(/^1[3456789]\d{9}$/.test(value))) {
                return Promise.reject('手机号不正确');
                } else {
                return Promise.resolve();
                }
            },
          }),
        ]}
    >
      <Input autocomplete="off" />
    </Form.Item>

    <Form.Item
     label="短信验证码" name="code"
      rules={[
          {
            required: true,
            message: '输入验证码',
          },
          () => ({
            validator(_, value) {
              if (value && !(/^\d{6}$/.test(value))) {
                return Promise.reject('输入6位验证码');
                } else {
                return Promise.resolve();
                }
            },
          }),
        ]}
    >
      <Input autocomplete="off" maxlength={6} />
    </Form.Item>

    <Form.Item
      label="新密码" name="password"
       rules={[
          {
            required: true,
            message: '输入密码',
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
                if (value && (!/^(?=.*[A-Za-z@$!%*?&])(?=.*\d)[A-Za-z\d@$!%*?&]{8,16}$/.test(value))) {
                    return Promise.reject('密码8到16位，数字、字母、特殊符号至少包含两种');
                }
              return Promise.resolve();
            },
          }),
        ]}
    >
      <Input.Password autocomplete="new-password" />
    </Form.Item>
    <Form.Item
      label="再次输入密码" name="checkPass"
      rules={[
          {
            required: true,
            message: '再次输入密码',
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (value && getFieldValue('password') != value) {
                return Promise.reject(new Error('两次密码不一致'));
              }
              
                return Promise.resolve();
            },
          }),
        ]}
    >
      <Input.Password autocomplete="new-password" />
    </Form.Item>
    <Form.Item label={null}>
      <Button type="primary" style={{marginLeft:'200px',paddingLeft:'50px',paddingRight:'50px'}} htmlType="submit">
        提交
      </Button>
    </Form.Item>
  </Form>
        </Modal>
 
}
  

export default App;